export { fastObjectShallowCompare } from "./fastObjectShallowCompare.js";